(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSSectorDeleteController',SSSectorDeleteController);

    SSSectorDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSSector'];

    function SSSectorDeleteController($uibModalInstance, entity, SSSector) {
        var vm = this;

        vm.sSSector = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSSector.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
